import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    standalone: false,
    selector: 'icms-hint-banner',
    templateUrl: 'icms-hint-banner.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styles: [
        `
            :host {
                display: block;
            }
        `
    ]
})
export class ICmsHintBannerComponent {
    @Input()
    fullWidth = false;

    @Input()
    title?: string;
}
